// extracted by mini-css-extract-plugin
module.exports = {"root":"_1htUR","icon":"_2YDNf","text":"_2VLw4"};